import React, { useEffect, useState } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
  TextField, IconButton, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Typography
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import axios from 'axios';
import * as constants from "../constants.js"
import { useNavigate } from "react-router-dom";

const ModifyAdminParameters = () => {
  const [parameters, setParameters] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedParameter, setSelectedParameter] = useState(null);
  const [name, setName] = useState('');
  const [value, setValue] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchParameters();
  }, []);

  const fetchParameters = async () => {
    try {
      const response = await axios.create({
          withCredentials: true,
      }).get("//" + constants.BASE_URL + "/getMyAdminParametersIds");
      const params = response.data;
      setParameters(params);
    } catch (error) {
      console.error("Error fetching parameters:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      const resp = await axios.create({
          withCredentials: true,
      }).post("//" + constants.BASE_URL + "/deleteAdminParameter", {
      id: id
      });
      setModalOpen(false);
      setSelectedParameter(null);
      setName('');
      setValue('');
      fetchParameters();
    } catch (error) {
      alert("Etwas ist schiefgegangen")
    }
  };

  const handleModify = async (param) => {
    setSelectedParameter(param);
    setName(param.name);
    setValue(param.value);
    setModalOpen(true);
  };

  const handleSave = async () => {
    if (selectedParameter) {
      try {
        const resp = await axios.create({
            withCredentials: true,
        }).post("//" + constants.BASE_URL + "/modifyAdminParameter", {
        name: name,
        value: value, 
        id: selectedParameter.id
        });
        setModalOpen(false);
        setSelectedParameter(null);
        setName('');
        setValue('');
        fetchParameters();
      } catch (error) {
        alert("Etwas ist schiefgegangen")
      }
    } else {
      try {
        const resp = await axios.create({
            withCredentials: true,
        }).post("//" + constants.BASE_URL + "/addAdminParameter", {
        name: name,
        value: value
        });
        setModalOpen(false);
        setSelectedParameter(null);
        setName('');
        setValue('');
        fetchParameters();
      } catch (error) {
        alert("Etwas ist schiefgegangen")
      }
    }

    
  };

  const handleCreateNew = () => {
    setSelectedParameter(null);
    setName('');
    setValue('');
    setModalOpen(true);
  };

  return (
    <div>
      <Typography variant="h4" gutterBottom>Admin Parameters</Typography>
      <Button variant="contained" color="primary" onClick={handleCreateNew}>
        Add New Parameter
      </Button>

      <TableContainer component={Paper} style={{ marginTop: '20px' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Value</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {parameters.map((param) => (
              <TableRow key={param.id}>
                <TableCell>{param.name}</TableCell>
                <TableCell>{param.value}</TableCell>
                <TableCell>
                  <IconButton color="primary" onClick={() => handleModify(param)}>
                    <Edit />
                  </IconButton>
                  <IconButton color="secondary" onClick={() => handleDelete(param.id)}>
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>{selectedParameter ? "Modify Parameter" : "Add New Parameter"}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Name"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Value"
            fullWidth
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalOpen(false)} color="secondary">Cancel</Button>
          <Button onClick={handleSave} color="primary">
            {selectedParameter ? "Save Changes" : "Add Parameter"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ModifyAdminParameters;
